import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ellipsis-filled",
  "use": "icon-ellipsis-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ellipsis-filled\"><circle cx=\"4\" cy=\"12\" r=\"2\" fill=\"currentColor\" /><circle cx=\"12\" cy=\"12\" r=\"2\" fill=\"currentColor\" /><circle cx=\"20\" cy=\"12\" r=\"2\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol